export default "__VITE_ASSET__RLVPrOv9__"